<template>
  <div class="flex items-center gap-8">
    <span class="c-partner-mapping-tab__status-dot" :class="dotColorClass" />
    <span class="text-sm" :class="textColorClass">
      {{ statusText }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { ICellRendererParams } from '@ag-grid-community/core';
import { computed } from 'vue';

const { params } = defineProps<{ params: ICellRendererParams }>();

const isMapped = computed(() => params.data.master_id !== null);

const statusText = computed(() => (isMapped.value ? 'Mapped' : 'Unmapped'));

const dotColorClass = computed(() =>
  isMapped.value ? 'bg-success-accent' : 'bg-warning-accent',
);

const textColorClass = computed(() =>
  isMapped.value ? 'text-success-text' : 'text-warning-text',
);
</script>

<style lang="pcss">
@reference "../../../../../css/theme.css";
.c-partner-mapping-tab__status-dot {
  @apply block w-8 h-8 rounded-full flex-shrink-0;
}

.c-partner-mapping-tab__status-dot.bg-success-accent {
  @apply bg-success-accent;
}

.c-partner-mapping-tab__status-dot.bg-warning-accent {
  @apply bg-warning-accent;
}
</style>
